/** محتوى صفحة ERP وأودو — مستوحى من aait.sa */

const AAIT_MEDIA = 'https://aait.sa/wp-content/uploads';

export const statsData = [
  { number: '+20', label: 'عامًا من الخبرة' },
  { number: '+500', label: 'شركة مستفيدة' },
  { number: '98', label: 'نسبة رضا العملاء %' },
  { number: '+24', label: 'ساعة دعم فني' },
];

/** Odoo · ERP مخصص · تكامل أنظمة */
export const platformsData = [
  {
    icon: 'ri-apps-2-line',
    name: 'نظام Odoo',
    description: 'شريك معتمد — أكثر من 30 تطبيقًا متكاملًا في واجهة واحدة',
  },
  {
    icon: 'ri-building-4-line',
    name: 'أنظمة ERP',
    description: 'تخطيط موارد المؤسسة — مالية، مخزون، موارد بشرية، وCRM',
  },
  {
    icon: 'ri-cloud-line',
    name: 'سحابة ودعم',
    description: 'استضافة، ترحيل بيانات، تدريب، ودعم فني على مدار الساعة',
  },
];

export const heroVisualData = {
  storeName: 'Odoo ERP',
  storeUrl: 'erp.company.sa',
  storeRating: 4.9,
  reviewCount: 'متصل · محدّث',
  banner: { text: 'تكامل المبيعات والمحاسبة والمخزون', icon: 'ri-links-line' },
  cartCount: 6,
  cartTotal: '12 تقرير',
  categories: ['الكل', 'المبيعات', 'المالية', 'المخزون'],
  activeCategory: 'المبيعات',
  paymentIcons: ['ri-apps-2-line', 'ri-building-4-line', 'ri-cloud-line'],
  products: [
    {
      name: 'إدارة المبيعات',
      category: 'المبيعات',
      price: '248 طلب',
      icon: 'ri-line-chart-line',
      accent: 'from-violet-500/35 via-indigo-900/50 to-slate-900',
      rating: 5,
      featured: true,
      sold: 'نشط',
      badge: { text: 'نشط', tone: 'amber' },
    },
    {
      name: 'المحاسبة',
      category: 'المالية',
      price: '1.2M ر.س',
      icon: 'ri-money-dollar-circle-line',
      accent: 'from-indigo-500/30 via-violet-950/60 to-slate-900',
      rating: 5,
      badge: { text: 'محدّث', tone: 'teal' },
    },
    {
      name: 'الموارد البشرية',
      category: 'الموارد البشرية',
      price: '86 موظف',
      icon: 'ri-team-line',
      accent: 'from-fuchsia-500/25 via-purple-950/40 to-slate-900',
      rating: 5,
    },
    {
      name: 'إدارة المخزون',
      category: 'المخزون',
      price: '1,420 صنف',
      icon: 'ri-archive-line',
      accent: 'from-blue-500/25 via-indigo-950/40 to-slate-900',
      rating: 4.9,
    },
    {
      name: 'علاقات العملاء',
      category: 'CRM',
      price: '340 عميل',
      icon: 'ri-customer-service-2-line',
      accent: 'from-violet-500/20 via-slate-900 to-indigo-950/50',
      rating: 4.8,
    },
    {
      name: 'المشتريات',
      category: 'المشتريات',
      price: '52 أمر',
      icon: 'ri-shopping-cart-line',
      accent: 'from-purple-500/25 via-slate-900 to-violet-950/50',
      rating: 4.9,
      badge: { text: 'ERP', tone: 'teal' },
    },
  ],
  cta: { primary: 'لوحة التحكم', secondary: 'Odoo · ERP · سحابة' },
  platforms: [
    { icon: 'ri-apps-2-line', name: 'Odoo' },
    { icon: 'ri-building-4-line', name: 'ERP' },
    { icon: 'ri-cloud-line', name: 'سحابة' },
  ],
  storesBadge: { value: '+500', label: 'شركة مستفيدة' },
};

export type HeroProduct = {
  name: string;
  category: string;
  price: string;
  oldPrice?: string;
  icon: string;
  accent: string;
  rating: number;
  featured?: boolean;
  sold?: string;
  badge?: { text: string; tone: string };
};

export const problemSolutionVisualData = {
  storeName: 'نظامك الموحد',
  storeUrl: 'dashboard.company.sa',
  cartCount: 4,
  cartTotal: '↑ 18% كفاءة',
  products: [
    { name: 'المالية والمحاسبة', price: 'متزامن', badge: 'ERP' },
    { name: 'المخزون والمشتريات', price: 'متزامن' },
    { name: 'الموارد البشرية', price: 'متزامن' },
    { name: 'المبيعات وCRM', price: 'متزامن', badge: 'Odoo' },
  ],
  orderPreview: {
    id: 'تقرير #Q2',
    status: 'جاهز',
    customer: 'تحليل الأداء',
    total: '↑ 18% كفاءة',
  },
  integrations: [
    { icon: 'ri-money-dollar-circle-line', label: 'المالية' },
    { icon: 'ri-archive-line', label: 'المخزون' },
    { icon: 'ri-team-line', label: 'الموارد البشرية' },
    { icon: 'ri-line-chart-line', label: 'المبيعات' },
    { icon: 'ri-customer-service-2-line', label: 'CRM' },
    { icon: 'ri-cloud-line', label: 'سحابة' },
  ],
  metrics: [
    { icon: 'ri-pie-chart-line', label: 'تكامل الأقسام', value: '100%' },
    { icon: 'ri-time-line', label: 'توفير الوقت', value: '+35%' },
  ],
};

export const featuresData = [
  {
    icon: 'ri-layout-grid-line',
    title: 'الشمولية',
    description:
      'تجمع أنظمة Odoo وظائف الأعمال في منصة واحدة ذات تنظيم وأيقونات واضحة لسهولة الوصول للقسم المطلوب.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'المرونة والتخصيص',
    description:
      'تتكيف مع احتياجات أعمالك وتقبل التعديل والتطوير بمرونة لتتوافق مع متطلباتك التشغيلية.',
  },
  {
    icon: 'ri-apps-line',
    title: 'مجموعة تطبيقات متكاملة',
    description:
      'أكثر من 30 تطبيقًا: الماليات، المبيعات، الموارد البشرية، التسويق، المخزون، والمشتريات.',
  },
  {
    icon: 'ri-robot-2-line',
    title: 'أتمتة العمليات',
    description:
      'أتمتة العمليات التجارية بجودة عالية لزيادة الكفاءة وإنهاء الفوضى في العمل الإداري.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'الأمان',
    description:
      'حماية مشاركة البيانات بين الأقسام مع أداء سريع دون أعطال برمجية مفاجئة.',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'تكلفة معقولة',
    description:
      'أفضل قيمة مقارنة بأنظمة ERP التقليدية — اعتماد مستقر دون تكاليف تشغيل مرتفعة.',
  },
  {
    icon: 'ri-mouse-line',
    title: 'سهل الاستخدام',
    description:
      'واجهة بديهية وأقسام واضحة تبسّط المهام الإدارية لجميع المستخدمين.',
  },
  {
    icon: 'ri-pie-chart-2-line',
    title: 'تقارير وتحليلات',
    description:
      'تقارير مفصلة وتحليلات لدعم اتخاذ القرار بناءً على بيانات دقيقة في أي وقت.',
  },
];

export const workStepsData = [
  {
    step: '01',
    title: 'تحليل احتياجات المؤسسة',
    description:
      'نفهم أقسامك، عملياتك، وأنظمتك الحالية لنحدد الحل الأنسب: Odoo أو ERP مخصص.',
  },
  {
    step: '02',
    title: 'التصميم والتخصيص',
    description:
      'نخصص الوحدات والواجهات وفق طبيعة عملك — مالية، مخزون، موارد بشرية، ومبيعات.',
  },
  {
    step: '03',
    title: 'الترحيل والتكامل',
    description:
      'نقل ودمج البيانات بشكل آمن مع أنظمتك الحالية لانتقال سلس دون تعطيل العمل.',
  },
  {
    step: '04',
    title: 'الاختبار والتدريب',
    description:
      'اختبار شامل للعمليات مع تدريب فريقك على الاستخدام الفعّال للنظام.',
  },
  {
    step: '05',
    title: 'الإطلاق والدعم',
    description:
      'تشغيل النظام على السحابة أو السيرفر مع دعم فني وتحديثات مستمرة.',
  },
];

export const servicesData = [
  {
    icon: 'ri-apps-2-line',
    title: 'تنفيذ نظام Odoo',
    description: 'شريك معتمد — تطبيق، تخصيص، وتدريب على منصة Odoo المتكاملة',
  },
  {
    icon: 'ri-building-4-line',
    title: 'أنظمة ERP مخصصة',
    description: 'حلول تخطيط موارد المؤسسات مصممة خصيصًا لاحتياجات نشاطك',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'الإدارة المالية والمحاسبة',
    description: 'تتبع الإيرادات والمصروفات والتدفق النقدي من لوحة تحكم واحدة',
  },
  {
    icon: 'ri-archive-line',
    title: 'إدارة المخزون والمشتريات',
    description: 'أتمتة الجرد والمشتريات وتقليل تكاليف إدارة المخزون',
  },
  {
    icon: 'ri-team-line',
    title: 'الموارد البشرية',
    description: 'من التوظيف إلى الرواتب والحضور والتقييمات — في نظام واحد',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'إدارة علاقات العملاء',
    description: 'متابعة العملاء والتواصل الاحترافي وبيانات موحدة للفريق',
  },
];

const ERP_IMAGES = '/images/erp';

export const portfolioData = [
  {
    title: 'لوحة الحضور والانصراف',
    category: 'Odoo · موارد بشرية',
    description:
      'مركز عمليات HR مباشر — حضور، تأخيرات، إجازات، وتقارير Power BI لمؤسسة موافقة العقارية',
    image: `${ERP_IMAGES}/hr-attendance.png`,
    imageBg: 'from-slate-800 via-slate-900 to-violet-950/40',
    wideImage: true,
  },
  {
    title: 'لوحة التحكم التشغيلية',
    category: 'ERP · عقارات',
    description:
      'مؤشرات العقارات، العقود، العملاء، والطلبات — لوحة موحدة لإدارة نشاط عقاري متكامل',
    image: `${ERP_IMAGES}/real-estate-dashboard.png`,
    imageBg: 'from-indigo-500/15 via-slate-900 to-violet-950/30',
    wideImage: true,
  },
  {
    title: 'إدارة الموظفين',
    category: 'Odoo · HR',
    description: 'دليل الموظفين والأقسام — عرض بطاقات مع الأدوار والبريد في واجهة عربية',
    image: `${ERP_IMAGES}/employees.png`,
    imageBg: 'from-violet-500/20 via-indigo-950/40 to-slate-900',
    wideImage: true,
  },
  {
    title: 'لوحة المحاسبة',
    category: 'Odoo · مالية',
    description: 'مبيعات، مشتريات، بنك، وتسوية — مؤشرات مالية وتقارير في لوحة واحدة',
    image: `${ERP_IMAGES}/accounting.png`,
    imageBg: 'from-blue-500/15 via-slate-900 to-indigo-950/50',
    wideImage: true,
  },
  {
    title: 'نظام الموافقات',
    category: 'Odoo · تشغيل',
    description:
      'سير عمل الموافقات — رحلات عمل، مشتريات، سلف، وتأجير سيارات ضمن منصة واحدة',
    image: `${ERP_IMAGES}/approvals.png`,
    imageBg: 'from-fuchsia-500/20 via-purple-950/35 to-slate-900',
    wideImage: true,
  },
  {
    title: 'تطبيقات Odoo المتكاملة',
    category: 'Odoo · منصة',
    description:
      'أكثر من 30 تطبيقًا — مبيعات، CRM، محاسبة، مخزون، موارد بشرية، وتسويق في واجهة واحدة',
    image: `${ERP_IMAGES}/odoo-apps.png`,
    imageBg: 'from-violet-500/25 via-violet-950/30 to-slate-900',
    wideImage: true,
  },
];

export const whyAAITVisualData = {
  dashboardTitle: 'لوحة ERP الموحدة',
  period: 'آخر 30 يومًا',
  kpis: [
    { icon: 'ri-money-dollar-circle-line', label: 'الإيرادات', value: '2.4M ر.س', trend: '+12%' },
    { icon: 'ri-archive-line', label: 'حركة المخزون', value: '8,420', trend: '+6%' },
    { icon: 'ri-team-line', label: 'الموظفون النشطون', value: '156', trend: 'مستقر' },
  ],
  recentOrders: [
    { id: 'فاتورة #891', customer: 'قسم المبيعات', amount: 'مكتمل', status: 'مكتمل' },
    { id: 'أمر شراء #120', customer: 'المشتريات', amount: 'جديد', status: 'جديد' },
    { id: 'تقرير HR', customer: 'الموارد البشرية', amount: 'قيد المراجعة', status: 'قيد المراجعة' },
  ],
  salesChart: [42, 58, 55, 72, 68, 85, 80],
  platforms: [
    { icon: 'ri-apps-2-line', name: 'Odoo', share: '55%' },
    { icon: 'ri-building-4-line', name: 'ERP مخصص', share: '30%' },
    { icon: 'ri-cloud-line', name: 'سحابة', share: '15%' },
  ],
  storesBadge: { value: '+500', label: 'شركة مستفيدة' },
  experienceBadge: { value: '+20', label: 'عامًا من الخبرة' },
};

export const whyAAITData = [
  {
    icon: 'ri-award-line',
    title: 'خبرة 20 عامًا',
    description: 'خدمات تسويقية وبرمجية في المملكة ومصر — شريك Odoo معتمد',
  },
  {
    icon: 'ri-medal-line',
    title: 'جودة تشغيل',
    description: 'نظام مؤسسي يستخدمه ملايين العملاء حول العالم بجودة دعم مثالية',
  },
  {
    icon: 'ri-star-line',
    title: 'سمعة واحترافية',
    description: 'آراء عملائنا في Odoo وERP تعكس علاقة جودة وحرص مستمر',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'إخلاص في الخدمة',
    description: 'نفس مستوى الجودة لجميع أحجام العملاء — صغار وكبار',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'ثقة وأمان',
    description: 'أولوية لخصوصية بياناتك بأحدث تقنيات الحماية والتشفير',
  },
];

export const testimonialsData = [
  {
    name: 'م. خالد الشمري',
    role: 'مدير عمليات — قطاع تجزئة',
    content:
      'نفّذوا لنا Odoo بشكل متكامل — المبيعات والمخزون والمحاسبة في مكان واحد. وفّر علينا وقتًا كبيرًا في التقارير.',
    rating: 5,
  },
  {
    name: 'نورة العتيبي',
    role: 'مديرة موارد بشرية',
    content:
      'نظام ERP مخصص لاحتياجاتنا — الحضور والرواتب والتقييمات أصبحت آلية. الدعم الفني سريع ومتعاون.',
    rating: 5,
  },
  {
    name: 'عبدالرحمن الغامدي',
    role: 'المدير المالي',
    content:
      'الترحيل من أنظمتنا القديمة إلى Odoo كان سلسًا. التقارير المالية دقيقة والواجهة سهلة للفريق.',
    rating: 5,
  },
];

export const navLinks = [
  { label: 'الرئيسية', href: '#hero' },
  { label: 'الحلول', href: '#platforms' },
  { label: 'المميزات', href: '#features' },
  { label: 'مراحل العمل', href: '#steps' },
  { label: 'أعمالنا', href: '#portfolio' },
  { label: 'الأسئلة الشائعة', href: '#faq' },
  { label: 'تواصل معنا', href: '#cta' },
];

export const faqData = [
  {
    question: 'ما الفرق بين Odoo وأنظمة ERP التقليدية؟',
    answer:
      'Odoo منصة مفتوحة المصدر بأكثر من 30 تطبيقًا متكاملًا وتكلفة معقولة. أنظمة ERP التقليدية غالبًا أغلى وأقل مرونة في التخصيص.',
  },
  {
    question: 'كم تستغرق مدة تنفيذ نظام Odoo أو ERP؟',
    answer:
      'يعتمد على حجم المؤسسة: من 4–8 أسابيع للمشاريع المتوسطة إلى 3–6 أشهر للمؤسسات الكبيرة مع تكاملات معقدة.',
  },
  {
    question: 'هل يمكن ترحيل بياناتنا من نظامنا الحالي؟',
    answer:
      'نعم، نقوم بنقل ودمج البيانات بشكل آمن ومنظم مع اختبار شامل قبل الإطلاق.',
  },
  {
    question: 'هل تقدمون استضافة سحابية ودعمًا بعد التشغيل؟',
    answer:
      'نعم — خدمات سحابة، دعم فني، تحديثات منتظمة، وتدريب لفريقك لضمان استمرارية العمل.',
  },
  {
    question: 'لماذا أوامر الشبكة لأنظمة ERP وOdoo؟',
    answer:
      'شريك Odoo معتمد، خبرة 20 عامًا، حلول مخصصة، أسعار تنافسية، ودعم فني على مدار الساعة في السعودية.',
  },
];

/** نصوص الأقسام الثابتة */
export const sectionCopy = {
  hero: {
    badge: 'Odoo معتمد · ERP · سحابة',
    titleLine1: 'أنظمة ERP وOdoo',
    titleGradient: 'لإدارة مؤسستك',
    titleSuffix: ' بكفاءة',
    subtitle:
      'مع أوامر الشبكة — تخطيط موارد المؤسسة، تخصيص Odoo، ترحيل البيانات، والدعم الفني من واجهة واحدة لجميع أقسامك.',
  },
  problem: {
    label: 'لماذا تحتاج ERP أو Odoo؟',
    titleLine1: 'ودّع الأنظمة',
    titleGradient: 'المعقدة والمتفرقة',
    description:
      'موارد مؤسستك ثروتك — نظام ERP من أوامر الشبكة يوحّد المالية والمخزون والموارد البشرية وعلاقات العملاء في منصة واحدة قابلة للتوسع.',
    highlights: [
      'تكامل العمليات في نظام واحد مع رؤية شاملة',
      'أتمتة المالية والمخزون والموارد البشرية',
      'تقارير وتحليلات لدعم قرارات أذكى',
      'Odoo معتمد أو ERP مخصص حسب ميزانيتك',
    ],
    badge: 'نظام متكامل',
  },
  platforms: {
    label: 'حلولنا',
    titleLine1: 'Odoo وERP',
    titleGradient: 'لجميع القطاعات',
    description:
      'شريك Odoo معتمد — ننفّذ ونخصّص وندعم أنظمة تخطيط موارد المؤسسات بما يناسب حجم نشاطك.',
  },
  features: {
    label: 'مميزات النظام',
    titleLine1: 'لماذا Odoo و',
    titleGradient: 'أنظمة ERP',
  },
  portfolio: {
    label: 'أعمالنا',
    titleLine1: 'نجاحات في',
    titleGradient: 'ERP وOdoo',
    description:
      'مشاريع حقيقية من معرض أوامر الشبكة — تكامل إداري وتشغيلي لقطاعات متنوعة.',
    ctaPrimary: 'اطلب عرض سعر',
    cardCta: 'اطلب نظامًا مشابهًا',
  },
  cta: {
    titleLine1: 'جاهز لتحويل',
    titleGradient: 'إدارة مؤسستك؟',
    description:
      'احصل على استشارة مجانية من فريق أوامر الشبكة — شريك Odoo معتمد — وسنساعدك في اختيار الحل الأنسب.',
  },
};
